import React from 'react';
import { Container, Typography, Box, Paper, Button, Grid } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';

function ContactPage() {
  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Button 
        component={RouterLink} 
        to="/" 
        startIcon={<ArrowBackIcon />} 
        sx={{ mb: 2 }}
      >
        Back to Map
      </Button>

      <Paper elevation={3} sx={{ p: 4, borderRadius: 2, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom color="primary">
          Contact Us
        </Typography>

        <Typography variant="body1" paragraph sx={{ mb: 4 }}>
          We love hearing from the community! Whether you have a suggestion, found a bug, or just want to share a photo of your display, here is how you can reach us.
        </Typography>

        <Grid container spacing={7} justifyContent="center">
          
          {/* Email Option */}
          <Grid item xs={12} sm={6}>
            <Box sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2, height: '100%' }}>
              <EmailIcon sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
              <Typography variant="h5" gutterBottom>Email Us</Typography>
              <Typography variant="body2" paragraph color="text.secondary">
                For general inquiries, support, or media requests.
              </Typography>
              <Button 
                variant="contained" 
                href="mailto:support@termplanner.com.au"
                size="large"
              >
                Send Email
              </Button>
            </Box>
          </Grid>

          {/* Facebook Option */}
          <Grid item xs={12} sm={6}>
            <Box sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2, height: '100%' }}>
              <FacebookIcon sx={{ fontSize: 60, color: '#1877F2', mb: 2 }} />
              <Typography variant="h5" gutterBottom>Facebook</Typography>
              <Typography variant="body2" paragraph color="text.secondary">
                Join our community for the latest updates and featured displays.
              </Typography>
              <Button 
                variant="contained" 
                href="https://www.facebook.com/profile.php?id=61585180973488" 
                target="_blank"
                rel="noopener noreferrer"
                size="large"
                sx={{ bgcolor: '#1877F2', '&:hover': { bgcolor: '#165dbb' } }}
              >
                Follow Page
              </Button>
            </Box>
          </Grid>

        </Grid>

        {/* --- REMOVED THE INVALID COMMENT BLOCK HERE --- */}
        <Box sx={{ mt: 4, p: 2, bgcolor: '#fff3e0', borderRadius: 3 }}>
          <Typography variant="body2" color="warning.dark">
            <strong>Note:</strong> We are a small team (of elves). We try to respond to all messages within 48 hours!
          </Typography>
        </Box>

      </Paper>
    </Container>
  );
}

export default ContactPage;